import { render } from "./InvalidRequest.vue?vue&type=template&id=0ac63dd4"
import script from "./InvalidRequest.vue?vue&type=script&lang=js"
export * from "./InvalidRequest.vue?vue&type=script&lang=js"
script.render = render

export default script